const BU = {
  GM: 1,
  PM: 2,
};

export default BU;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/enums/accountBusinessUnits.js